import React,{useRef,useState} from 'react'
import {Link} from 'react-router-dom'
import extendedLogo from '../assets/hacklab-extended-white.png'

// Same layout pattern as orbit-analytics's MarketingHeader (sticky, blurred,
// logo left / pill nav center / CTA right, hamburger on mobile), restyled
// with the media-kit colors. Nav items are placeholders — there's nothing to
// link to yet since the rest of the site hasn't been rebuilt.
//
// Each nav item reuses one of the media kit's actual background/text color
// pairs (media kit 26_27/palettes color description.png), so the hover oval
// always lands on a real brand combo instead of an invented one.
const NAV_ITEMS=[
    {label: 'Home', href: '/', bg: '#5b4bff', fg: '#ffffff'},
    {label: 'About', href: '/about', bg: '#ff8a3d', fg: '#6b123a'},
    {label: 'Team', href: '#', bg: '#b9f227', fg: '#152238'},
    {label: 'Contact', href: '/contact', bg: '#37d5d3', fg: '#3d5afe'},
]

function NavPill() {
    const containerRef=useRef(null)
    const itemRefs=useRef([])
    const [hover,setHover]=useState(null)

    const handleEnter=(i,el) => {
        const container=containerRef.current
        if(!container||!el) return
        setHover({
            index: i,
            left: el.offsetLeft,
            width: el.offsetWidth,
        })
    }

    return (
        <nav
            ref={containerRef}
            onMouseLeave={() => setHover(null)}
            className='hidden relative gap-1 items-center p-1 rounded-full border md:inline-flex border-dark-700 bg-dark-900/60'
        >
            <span
                aria-hidden='true'
                className='absolute top-1 bottom-1 rounded-full transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]'
                style={{
                    left: hover? hover.left:0,
                    width: hover? hover.width:0,
                    opacity: hover? 1:0,
                    backgroundColor: hover? NAV_ITEMS[hover.index].bg:'transparent',
                }}
            />
            {NAV_ITEMS.map((item,i) => (
                <Link
                    key={item.label}
                    to={item.href}
                    ref={el => {itemRefs.current[i]=el}}
                    onMouseEnter={e => handleEnter(i,e.currentTarget)}
                    className='relative z-10 px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-500'
                    style={{color: hover&&hover.index===i? item.fg:'#a3abb2'}}
                >
                    {item.label}
                </Link>
            ))}
        </nav>
    )
}

export default function Header() {
    const [open,setOpen]=useState(false)

    return (
        <header className='sticky top-0 z-30 border-b backdrop-blur bg-dark/85 border-dark-800'>
            <div className='grid grid-cols-3 items-center px-4 py-3 mx-auto max-w-6xl'>
                <Link to='/' className='flex items-center'>
                    <img src={extendedLogo} alt='theHackLab Bocconi Students' className='h-12 w-auto' />
                </Link>

                <div className='flex justify-center'>
                    <NavPill />
                </div>

                <div className='flex gap-3 justify-end items-center'>
                    <div className='hidden gap-3 items-center md:flex'>
                        <Link to='/contact' className='px-4 py-2 text-sm font-semibold rounded-full border transition-colors border-dark-700 text-light hover:border-accent'>Contact</Link>
                        <a href='https://forms.gle/1j154P2cXjkGg2968' className='px-4 py-2 text-sm font-semibold rounded-full btn-sweep'>Get Involved</a>
                    </div>

                    <button
                        type='button'
                        aria-label={open? 'Close menu':'Open menu'}
                        aria-expanded={open}
                        onClick={() => setOpen(v => !v)}
                        className='flex justify-center items-center w-9 h-9 rounded-full border md:hidden border-dark-700 text-light'
                    >
                        {open? (
                            <svg width='16' height='16' viewBox='0 0 18 18' fill='none'><path d='M3 3l12 12M15 3L3 15' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' /></svg>
                        ):(
                            <svg width='16' height='16' viewBox='0 0 18 18' fill='none'><path d='M2 5h14M2 9h14M2 13h14' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' /></svg>
                        )}
                    </button>
                </div>
            </div>

            {open&&(
                <div className='flex flex-col gap-1 px-4 pb-4 md:hidden'>
                    {NAV_ITEMS.map(item => (
                        <Link key={item.label} to={item.href} onClick={() => setOpen(true)} className='px-3 py-2 text-sm font-medium rounded-lg text-dark-300'>{item.label}</Link>
                    ))}
                    <a href='https://forms.gle/1j154P2cXjkGg2968' className='px-4 py-2 mt-2 text-center rounded-full btn-sweep'>Get Involved</a>
                </div>
            )}
        </header>
    )
}
